import { Routes, Route } from 'react-router-dom';
import { NcdForm } from '../modules/ncd/components/NcdForm';
import { BreastScreening } from '../modules/ncd/components/BreastcancerFollowup/BreastScreening';
import { CervicalScreening } from '../modules/ncd/components/CervicalcancerFollowup/CervicalScreening';
import { OralScreening } from '../modules/ncd/components/OralcancerFollowup/OralScreening';
import { Diabetes } from '../modules/ncd/components/Diabetes';
import { Hypertension } from '../modules/ncd/components/Hypertension';

const NCDRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<NcdForm />} />
      <Route path="/form" element={<NcdForm />} />
      <Route path="/breast-screening" element={<BreastScreening />} />
      <Route path="/cervical-screening" element={<CervicalScreening />} />
      <Route path="/oral-screening" element={<OralScreening />} />
      <Route path="/diabetes" element={<Diabetes />} />
      <Route path="/hypertension" element={<Hypertension />} />
    </Routes>
  );
};

export default NCDRoutes;